/**
 * LocalStorage 工具
 */

import { logger } from './logger';

class StorageService {
  /**
   * 保�??�据
   */
  set<T>(key: string, value: T): boolean {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(key, serialized);
      return true;
    } catch (error) {
      logger.error(`Failed to save to localStorage: ${key}`, error);
      return false;
    }
  }

  /**
   * 获取数据
   */
  get<T>(key: string): T | undefined;
  get<T>(key: string, defaultValue: T): T;
  get<T>(key: string, defaultValue?: T): T | undefined {
    try {
      const item = localStorage.getItem(key);
      if (item === null) {
        return defaultValue;
      }
      return JSON.parse(item) as T;
    } catch (error) {
      logger.error(`Failed to read from localStorage: ${key}`, error);
      return defaultValue;
    }
  }

  /**
   * ?�除?�据
   */
  remove(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      logger.error(`Failed to remove from localStorage: ${key}`, error);
      return false;
    }
  }

  /**
   * 清空?�?�数??
   */
  clear(): boolean {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      logger.error('Failed to clear localStorage', error);
      return false;
    }
  }

  /**
   * 检?�键?�否存在
   */
  has(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }

  /**
   * ?��??�?�键
   */
  keys(): string[] {
    return Object.keys(localStorage);
  }

  /**
   * ?��?缓�??�据（带过�??�间�?
   */
  getCache<T>(key: string, expiryMs: number): T | null {
    try {
      const item = localStorage.getItem(key);
      if (item === null) {
        return null;
      }

      const cached = JSON.parse(item) as { data: T; timestamp: number };
      const now = Date.now();

      if (now - cached.timestamp > expiryMs) {
        // 缓�?过�?
        this.remove(key);
        return null;
      }

      return cached.data;
    } catch (error) {
      logger.error(`Failed to read cache from localStorage: ${key}`, error);
      return null;
    }
  }

  /**
   * 设置缓�??�据（带?�间?��?
   */
  setCache<T>(key: string, value: T): boolean {
    try {
      const cached = {
        data: value,
        timestamp: Date.now(),
      };
      return this.set(key, cached);
    } catch (error) {
      logger.error(`Failed to save cache to localStorage: ${key}`, error);
      return false;
    }
  }
}

// 导出?��?
export const storage = new StorageService();


